import React from "react";
import { Input, Check, Textarea } from "../../";
import locales from "../../../constants";

const SubmitStep = ({
  register,
  errors,
  step,
  setStep,
  triggerValidation,
  formState,
  lang,
}) => {
  const translation = locales[lang];

  return (
    <>
      <div
        className="step_4 stepWrapper"
        style={{ display: step === 4 ? "block" : "none" }}
      >
        <p className="desc">{translation.brief_shop.step_4_desc}</p>
        <div className="row">
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="design"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_materials_head}</h4>
                  <p>{translation.brief_shop.step_4_materials_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="adds"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_advertise_head}</h4>
                  <p>{translation.brief_shop.step_4_advertise_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="visualizations"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_visualization_head}</h4>
                  <p>{translation.brief_shop.step_4_visualization_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="positioning"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_positioning_head}</h4>
                  <p>{translation.brief_shop.step_4_positioning_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="pr_marketing"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_pr_head}</h4>
                  <p>{translation.brief_shop.step_4_pr_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="social_media_check"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_sm_head}</h4>
                  <p>{translation.brief_shop.step_4_sm_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="photo_session"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_session_head}</h4>
                  <p>{translation.brief_shop.step_4_session_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="print"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_print_head}</h4>
                  <p>{translation.brief_shop.step_4_print_desc}</p>
                </>
              }
            />
          </div>
          <div className="col-md-4 brief_col">
            <Check
              register={register}
              name="video"
              label={
                <>
                  <h4>{translation.brief_shop.step_4_video_head}</h4>

                  <p>{translation.brief_shop.step_4_video_desc}</p>
                </>
              }
            />
          </div>
        </div>
        <div className="row brief_row">
          <div className="col-md-5">
            <h4>{translation.brief_shop.step_4_other_head}</h4>
            <p>{translation.brief_shop.step_4_other_desc}</p>
            <p></p>
          </div>
          <div className="col-md-5 offset-md-2">
            <Textarea
              cols="40"
              rows="3"
              name="other_services"
              label={translation.brief_shop.step_4_other}
              register={register}
              errors={errors}
            />
          </div>
        </div>
        <div className="row brief_row">
          <div className="col-md-5">
            <h4>{translation.brief_shop.step_4_how_head}</h4>
          </div>
          <div className="col-md-5 offset-md-2">
            <Input
              type="text"
              name="get_from"
              label={translation.brief_shop.step_4_how}
              register={register}
              errors={errors}
            />
          </div>
        </div>
        <div className="row brief_row">
          <div className="col-md-5">
            <h4>{translation.brief_shop.step_4_keeper_head}</h4>
          </div>
          <div className="col-md-5 offset-md-2">
            <div className="select_wrapper">
              <select ref={register} name="client_guardian">
                <option value="Brak">
                  {translation.brief_shop.step_4_keeper_option}
                </option>
                <option value="Łukasz Pach">Łukasz Pach</option>
                <option value="Wojciech Kmiecik">Wojciech Kmiecik</option>
                <option value="Marcin Iglicki">Marcin Iglicki</option>
                <option value="Katarzyna Bartyzel">Katarzyna Bartyzel</option>
              </select>
            </div>
          </div>
        </div>
        <Check
          register={register}
          name="term1"
          size="sm"
          validation={{ required: "Wymagane" }}
          errors={errors}
          label={translation.brief_shop.step_4_legal_first}
        />
        <Check
          register={register}
          name="term2"
          size="sm"
          label={translation.brief_shop.step_4_legal_second}
        />
        <Check
          register={register}
          name="term3"
          size="sm"
          label={translation.legal_third}
        />
        <div className="divider" />
        <p>{translation.brief_shop.step_4_legal_third}</p>
        <div className="divider" />
        <div className="btn-brief-group">
          <button
            type="button"
            className="btn_brief stepWrapperBtn"
            onClick={() => setStep(3)}
          >
            {translation.brief_shop.step_1_prev_step}
          </button>
          <button
            type="submit"
            className="btn_brief"
            onClick={async () => {
              await triggerValidation([{ name: "term1" }]);
            }}
          >
            {translation.brief_shop.step_4_send}
          </button>
        </div>
      </div>
    </>
  );
};
export default SubmitStep;
